class Inquiry {
  constructor(
    id,
    inquirer,
    email,
    category,
    content,
    isAnswered,
    createdAt,
    updatedAt
  ) {
    if (!(typeof id === "string")) {
      throw new TypeError(`The type of 'id' must be String. Actual: ${typeof id}`)
    }
    this.id = id
    this.inquirer = inquirer
    this.email = email
    this.category = category
    this.content = content
    this.isAnswered = isAnswered
    this.createdAt = createdAt
    this.updatedAt = updatedAt
  }

  toObject() {
    return {
      id: this.id,
      data: {
        inquirer: this.inquirer,
        email: this.email,
        category: this.category,
        content: this.content,
        isAnswered: this.isAnswered,
        createdAt: this.createdAt,
        updatedAt: this.updatedAt
      }
    }
  }

  toAnswered() {
    this.isAnswered = true
    return this
  }
}

class Inquiries {
  constructor(
    inquiries
  ) {
    this.inquiries = inquiries
  }

  toObject() {
    return this.inquiries.map(inquiry => {
      return inquiry.toObject()
    })
  }

  get() {
    return this.inquiries
  }
}

const InquiryCategory = [
  '体験授業について',
  'アカウントについて',
  '利用規約について',
  '授業料について',
  'その他'
]

Object.freeze(InquiryCategory)

export { Inquiry, Inquiries, InquiryCategory }